import React from "react";
import { Card, Table, Tag } from "antd";

interface BillingHistoryCardProps {
  columns: any;
  data: any;
}

const BillingHistoryCard: React.FC<BillingHistoryCardProps> = ({ columns, data }) => {
  return (
    <Card title="Billing History spacing">
      <Table columns={columns} dataSource={data} pagination={false} />
    </Card>
  );
};

export default BillingHistoryCard;
